<template>
  <div class="textField">
    <input
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      v-on:blur="$emit('blur')"
      :placeholder="placeholder"
      :type="type"
      autocomplete="off">
  </div>
</template>

<script>
export default {
  name: "PTextField",
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.textField {
  margin: 20px 30px 0;
  input {
    appearance: none !important;
    width: 315px;
    border: 1px solid #8D7F81;
    border-radius: 50px;
    padding: 10px 15px;
    font-size: 12px;
    color: #8D7F81 !important;
    background-color: #FBFCFD;
    outline: none;
    &:-webkit-autofill {
      -webkit-text-fill-color: #8D7F81 !important;
    }
    &::focus {
      border: 1px solid #F63C5B !important;
      outline: none;
    }
    &::placeholder,
    &::selection { color: #8D7F81 !important; }
  }
}
</style>
